import React, { useState } from "react";

export default function AgriLoanForm() {
  const [agree, setAgree] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    purpose: "",
    farmerName: "",
    farmSize: "",
    location: "",
    cropType: "",
    loanAmount: "",
    emiCount: "",
    annualIncome: "",
    collateral: "",
    remarks: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agree) {
      alert("⚠️ You must agree to the Terms & Conditions before submitting.");
      return;
    }
    // console.log("Loan Application Submitted:", formData);
    alert("✅ Loan Application submitted! Our Agri Finance Partner will contact you.");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-black p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-green-800 shadow-lg rounded-2xl p-6 w-full border border-green-200"
      >
        <h2 className="text-xl font-bold text-center text-yellow-200 mb-6">
          🌱 AgriLoan: Empowering Farmers with Easy Loan Solutions
        </h2>

        {/* Loan Purpose */}
        <label className="block mb-2 font-medium">Loan Purpose</label>
        <select
          name="purpose"
          value={formData.purpose}
          onChange={handleChange}
          className="h-10 p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select Purpose --</option>
          <option value="Seeds">Seeds</option>
          <option value="Fertilizers">Fertilizers</option>
          <option value="Equipment">Farm Equipment</option>
          <option value="Irrigation">Irrigation</option>
          <option value="Storage">Storage/Cold Chain</option>
          <option value="Other">Other</option>
        </select>

        {/* Farmer Details */}
        <label className="block mb-2 font-medium">Farmer Name</label>
        <input
          type="text"
          name="farmerName"
          value={formData.farmerName}
          onChange={handleChange}
          style={{width: "100%"}}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Farm Size (in Acres)</label>
        <input
          type="number"
          name="farmSize"
          value={formData.farmSize}
          onChange={handleChange}
          className="w-24 p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Farm Location</label>
        <input
          type="text"
          name="location"
          value={formData.location}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Primary Crop Type</label>
        <input
          type="text"
          name="cropType"
          value={formData.cropType}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        {/* Financial Details */}
        <label className="block mb-2 font-medium">Loan Amount (₹)</label>
        <input
          type="number"
          name="loanAmount"
          value={formData.loanAmount}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Repayment Period</label>
        <select
          name="emiCount"
          value={formData.emiCount}
          onChange={handleChange}
          className="h-10 w-full p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select Loan Duration --</option>
          <option value="3">3 months</option>
          <option value="6">6 months</option>
          <option value="9">9 months</option>
          <option value="12">12 months</option>
          <option value="24">24 months</option>
        </select>

        <label className="block mb-2 font-medium">Annual Income (₹)</label>
        <input
          type="number"
          name="annualIncome"
          value={formData.annualIncome}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Collateral (if any)</label>
        <input
          type="text"
          name="collateral"
          value={formData.collateral}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        {/* Remarks */}
        <label className="block mb-2 font-medium">Remarks</label>
        <textarea
          name="remarks"
          value={formData.remarks}
          onChange={handleChange}
          style={{height: "250px", width: "100%"}}
          className="w-full bg-gray-100 text-black p-2 mb-4 border rounded-lg text-sm"
        />

        {/* Terms & Conditions */}
        <div className="flex items-center mb-4">
          <input
            type="checkbox"
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
            className="mr-2"
          />
          <button
            type="button"
            onClick={() => setShowModal(true)}
            
          >
            I agree to the Terms & Conditions
          </button>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="w-full text-white py-2 rounded-lg"
        >
          Submit Application
        </button>
      </form>

      {/* Terms Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-green-700 rounded-2xl shadow-lg w-11/12 max-w-2xl p-6 overflow-y-auto max-h-[80vh]">
            <h2 className="text-xl font-bold mb-4 text-center text-yellow-200">
              🌿 AgriLoan Terms & Conditions
            </h2>
            <div className="text-sm text-white space-y-3">
              <p>1. Loans facilitated via AgriLink are disbursed by authorized NBFCs/Banks.</p>
              <p>2. Applicants must provide valid KYC and farm ownership details.</p>
              <p>3. Repayments must be made on time; defaults may affect credit score.</p>
              <p>4. Loan amounts may be disbursed directly to agri input vendors or institutions.</p>
              <p>5. AgriLink is not responsible for delays caused by financial partners.</p>
              <p>6. Data will be kept confidential and only shared with authorized lenders.</p>
              <p>7. All disputes fall under Indian jurisdiction (Mumbai courts).</p>
            </div>
            <div className="mt-6 flex justify-center">
              <button
                onClick={() => setShowModal(false)}
                className="bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
